import type { BalanceApiEntry } from '@features/balanceLedger/config/balanceSideConfig'
// TODO(AUDIT-255): cross-view import until balance ledger utils are extracted into the feature.
import type { LedgerEntryIdPrefix } from '@views/suppliersBalance/enums/ledgerEntryIdPrefix'
import type { LedgerEntry } from '@views/suppliersBalance/types/LedgerEntry'
import { minorToMajor } from '@views/suppliersBalance/utils/moneyUtils'

export const normalizeDebtorLedgerEntry = (
  entry: BalanceApiEntry,
  index: number,
  idPrefix: LedgerEntryIdPrefix,
): LedgerEntry => {
  const debitMinor = entry.debit.value
  const creditMinor = entry.credit.value
  const isZeroAmountEntry = debitMinor === 0 && creditMinor === 0

  return {
    id: `${idPrefix}-${entry.originatorType}-${entry.originatorRef}-${index}`,
    date: entry.entryDate,
    journal: entry.journal ?? '',
    description: entry.description ?? '',
    documentNumber: entry.bill?.documentNumber ?? '',
    transactionId: entry.transactionId ?? undefined,
    debit: isZeroAmountEntry || debitMinor !== 0 ? minorToMajor(debitMinor) : null,
    credit: isZeroAmountEntry || creditMinor !== 0 ? minorToMajor(creditMinor) : null,
    balance: minorToMajor(entry.runningBalance.value),
    isOpeningBalance: entry.isOpeningBalance,
  }
}
